import { render, staticRenderFns } from "./EditClientClaim.vue?vue&type=template&id=00212f76&"
import script from "./EditClientClaim.vue?vue&type=script&lang=js&"
export * from "./EditClientClaim.vue?vue&type=script&lang=js&"
import style0 from "./EditClientClaim.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EditClientClaim.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports